<template>
  <a ref="Icon2dLink">
    <img
      @click="show()"
      :src="appUrl + '/img/icons/2d-icon.svg'"
      class="icon icon2d"
      :class="{
        'is-set-icon': isSetIcon,
        'number-items-4': isNumberItems4,
        'is-overview': isOverview,
        'is-addon-list': isAddonList,
        'mode-conf': visualMode === 'conf',
        'no-conf-mode': visualMode !== 'conf',
      }"
      alt="2D"
      title="2D View"
    />
    <label></label>
  </a>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "Icon2d",
  props: [
    "set",
    "isSetIcon",
    "visualMode",
    "isNumberItems4",
    "isOverview",
    "isAddonList",
  ],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
    };
  },
  methods: {
    show: function () {
      let currentItem = this.set.currentItem;
      if (this.set.items.length < 2) {
        currentItem = "overview";
      }

      this.$parent["show3dIcon"] = true;
      this.$parent.$parent.$parent["hideImage"][currentItem] = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .icon.icon2d {
    margin-left: 0;
    width: 3.5rem;
    margin-top: 0;

    @media (min-width: 768px) {
      width: 4.5rem;
    }

    &.is-set-icon,
    &.is-addon-list {
      margin-top: 4.5rem;

      @media (min-width: 768px) {
        margin-top: 5.75rem;
      }
    }

    &.is-set-icon.mode-conf,
    &.is-set-icon.no-conf-mode {
      &.is-addon-list {
        margin-top: 16.5rem;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        &.is-addon-list {
          margin-top: 17rem;
        }
      }

      @media (min-width: 992px) {
        &.is-addon-list {
          margin-top: 15rem;
        }
      }
    }

    &.is-addon-list.mode-conf,
    &.is-addon-list.no-mode-conf {
      &.is-set-icon {
        margin-top: 16.5rem;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        &.is-set-icon {
          margin-top: 17rem;
        }
      }

      @media (min-width: 992px) {
        &.is-set-icon {
          margin-top: 15rem;
        }
      }
    }

    &.number-items-4.is-overview,
    &.is-addon-list.is-set-icon.no-conf-mode {
      @media (max-width: 767px) {
        margin-top: 24rem;

        @media (min-width: 375px) {
          margin-top: 29rem;
        }

        @media (min-width: 425px) {
          margin-top: 34rem;
        }
      }
    }
  }

  label {
    margin: 0;
    padding: 0;
  }
}
</style>
